import React, { memo, useMemo } from 'react';
import { Box } from '@mui/system';
import { useTheme } from '@mui/material/styles';
import BehaviorAction from './BehaviorAction';
import { DashedHr } from './BehaviorChallengesDetails';
import { Typography } from '@mui/material';

const AdditionalSection = memo(({ id, title = '', actions = [] }) => {
  const theme = useTheme();

  const memoizedActions = useMemo(() => actions, [actions]);

  return (
      <Box
        id={`${id}-div`}
        sx={{
          width: '100%',
          ml: 'auto',
          mr: 'auto',
          mb: '4rem',
          maxWidth: {
            xs: '375px',
            sm: '540px',
            md: '768px',
            lg: '1180px',
            xl: '1180px',
          },
          paddingTop: '30px',
          display: 'flex',
          flexDirection: {
            xs: 'column',
            sm: 'row',
          },
          gap: '40px',
        }}
      >
        <Box
          id={`${id}-title-div`}
          sx={{
            backgroundColor: theme.palette.obsPrevention.main,
            width: 'auto',
            minWidth: {
              xs: 'auto',
              sm: '327px',
            },
            maxWidth: {
              xs: 'auto',
              sm: '327px',
            },
            height: '100%',
            minHeight: {
              xs: '250px',
              sm: '327px',
            },
            paddingLeft: '20px',
            paddingRight: '30px',
            marginTop: '20px',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          {title && (
            <Typography
              sx={{
                font: 'Source Sans Pro',
                color: theme.palette.text.white || '#ffffff',
                fontSize: '42px',
                fontWeight: '600',
                lineHeight: '46px',
                listSpacing: '0px',
              }}
            >
              {title}
            </Typography>
          )}
        </Box>
        <Box id={`${id}-details-div`}>
          {memoizedActions.map((action, index, arr) => (
            <React.Fragment key={index}>
              <BehaviorAction
                id={`${id}-action-${index}`}
                action={action.fields}
              />
              {arr.length > 1 && index < arr.length - 1 && <DashedHr />}
            </React.Fragment>
          ))}
        </Box>
      </Box>
  );
});

AdditionalSection.displayName = 'AdditionalSection';

export default AdditionalSection;
